import { IToasterConfig as ToastConfig } from 'angular2-toaster';
import { IToasterData } from './toaster.data';

// action payload interfaces
export interface IToastIdsPayload {
  toastId: string;
  toastContainerId: number;
}

export interface IToastConfigPayload {
  toastConfig: ToastConfig;
}

export interface IToastDataPayload {
  toasterData: IToasterData;
}

// action enums
export enum ActionsEnum {
  SHOW_TOAST = 'SHOW_TOAST',
  CLEAR_TOAST = 'CLEAR_TOAST',
  UPDATE_TOASTER_DATA = 'UPDATE_TOASTER_DATA',
}

// action definitions
export interface ShowToast {
  type: ActionsEnum.SHOW_TOAST;
  payload: IToastConfigPayload;
}

export interface ClearToast {
  type: ActionsEnum.CLEAR_TOAST;
  payload: IToastIdsPayload;
}

export interface UpdateToasterData {
  type: ActionsEnum.UPDATE_TOASTER_DATA;
  payload: IToastDataPayload;
}

// action creators
export const showToast = (toastConfig: ToastConfig): ShowToast => ({
  type: ActionsEnum.SHOW_TOAST,
  payload: {
    toastConfig,
  },
});

export const clearToast = (
  toastId: string,
  toastContainerId: number
): ClearToast => ({
  type: ActionsEnum.CLEAR_TOAST,
  payload: {
    toastId,
    toastContainerId,
  },
});

export const updateToasterData = (
  toasterData: IToasterData
): UpdateToasterData => ({
  type: ActionsEnum.UPDATE_TOASTER_DATA,
  payload: {
    toasterData,
  },
});
